//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                resultInfo:{}, //查询结果
                security_code: this.$route.query.security_code, //防伪码
            }
        },
        created() {
            this.securityCode = this.security_code.toUpperCase().replace(/(.{4})/g, "$1 ");
            var resultInfo = sessionStorage.getItem('haijiInquireResult') ? JSON.parse(sessionStorage.getItem('haijiInquireResult')) : {};
            this.resultInfo = resultInfo;
        },
        methods: {
            copyText(text) {
                this.$copyText(text);
                this.$vux.toast.text('复制成功');
            }
        }
    }
